export const formatDkkAmount = (value) => {
    const n = typeof value === 'number' ? value : parseFloat(value);
    if (!Number.isFinite(n)) {
        return String(value);
    }
    return n.toLocaleString('da-DK', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
/**
 * Chart labels (pie slice labels, axis ticks) have no layout to wrap in, so
 * unbounded user text (creditor names, update type labels, ...) must be
 * truncated. The full text stays available in the chart tooltip.
 */
export const truncateChartLabel = (value, maxLength = 16) => {
    const label = typeof value === 'string'
        ? value
        : typeof value === 'number'
            ? String(value)
            : '';
    return label.length > maxLength ? `${label.slice(0, maxLength - 1)}…` : label;
};
export const formatHoursAsDuration = (hours) => {
    if (!Number.isFinite(hours) || hours <= 0) {
        return '0m';
    }
    const totalMinutes = Math.round(hours * 60);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    if (h === 0) {
        return `${m}m`;
    }
    if (m === 0) {
        return `${h.toLocaleString('da-DK')}t`;
    }
    return `${h.toLocaleString('da-DK')}t ${m}m`;
};
//# sourceMappingURL=helpers.js.map